'use strict';

angular.module('internal.services')
    .controller('InternalService', ['$scope', '$stateParams', 'Services', '$rootScope', '$http', function ($scope, $stateParams, Services, $rootScope, $http) {
        $scope.masterService = $stateParams.service;
        $scope.service = $stateParams.service;
        $scope.serviceID = $stateParams.id;
        $scope.serviceLoading = true;

        $scope.setMasterService = function (service) {
            $scope.masterService = service;
            $scope.service = angular.copy($scope.masterService);
        }

        $scope.resetService = function () {
            if ($scope.masterService == null) {
                $scope.masterService = {};
            }
            $scope.service = angular.copy($scope.masterService);
        }

        $scope.getService = function () {
            Services.getByID($stateParams.id).then(function (service) {
                $scope.serviceLoading = false;
                $scope.setMasterService(service);
            })
        }

        $scope.syncService = function () {
            $http({
                method: 'POST',
                url: $rootScope.internalURL + 'license/controller.cfm?method=cnt_services.bulkPushServiceRecordsByServiceIDs&triggered=true&serviceIDs=' + $scope.serviceID
            })
            .then(function (response) {
                $scope.syncInitiated = true;
            })
            .catch(function (response) {
                // handle error
            });


        }

        if ($stateParams.id != null) {
            $scope.getService();
        }
        else {
            var service = {};
            service.complaints = [];
            service.alerts = [];
            $scope.serviceLoading = false;
            $scope.setMasterService(service);
        }
    }])
;